// PisosMoneyTokens.jsx

import React, { useEffect, useState } from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";

const MONEY_TOKENS = [
    { value: 100, label: "100k", color: "#CFFF60", textColor: "#111111" },
    { value: 50, label: "50k", color: "#FFFB00", textColor: "#111111" },
    { value: 20, label: "20k", color: "#DADADA", textColor: "#111111" },
    { value: 10, label: "10k", color: "#44000F", textColor: "#ffffff" },
    { value: 5, label: "5k", color: "#133B00", textColor: "#ffffff" },
    { value: 2.5, label: "2,5k", color: "#000000", textColor: "#ffffff" },
];

const roundMoney = (n) => Math.round(Number(n) * 100) / 100;

const formatMoney = (n) => {
    const num = roundMoney(n);
    if (Number.isNaN(num)) return "0";

    const text = Number.isInteger(num)
        ? String(num)
        : num.toFixed(2).replace(/\.?0+$/, "");

    return text.replace(".", ",");
};

const getTokenPairs = (amount, unavailableValues = []) => {
    let remaining = Math.round(roundMoney(Math.abs(amount) / 2) * 100);
    const unavailable = new Set(unavailableValues);

    const tokens = MONEY_TOKENS.filter((token) => !unavailable.has(token.value))
        .map((token) => {
            const tokenValue = Math.round(token.value * 100);
            const count = Math.floor(remaining / tokenValue);
            remaining -= count * tokenValue;

            return { ...token, count };
        })
        .filter((token) => token.count > 0);

    return {
        tokens,
        rest: roundMoney(remaining / 100),
    };
};

const PisosMoneyTokens = ({ amount }) => {
    const [unavailableValues, setUnavailableValues] = useState([]);
    const total = roundMoney(Math.abs(amount));
    const half = roundMoney(total / 2);

    useEffect(() => {
        setUnavailableValues([]);
    }, [amount]);

    if (!total) return null;

    const { tokens, rest } = getTokenPairs(total, unavailableValues);
    if (!tokens.length) return null;

    return (
        <Paper variant="outlined" sx={{ p: 0.75 }}>
            <Stack spacing={0}>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.25 }}>
                    {tokens.map((token) => (
                        <Box
                            key={token.label}
                            onClick={() =>
                                setUnavailableValues((prev) =>
                                    prev.includes(token.value)
                                        ? prev
                                        : [...prev, token.value],
                                )
                            }
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 0.75,
                                border: 1,
                                borderColor: "divider",
                                borderRadius: 4,
                                px: 1,
                                py: 0.75,
                                cursor: "pointer",
                                userSelect: "none",
                            }}
                        >
                            <Box
                                sx={{
                                    width: 36,
                                    height: 24,
                                    borderRadius: "25%",
                                    bgcolor: token.color,
                                    color: token.textColor,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 12,
                                    fontWeight: 900,
                                }}
                            >
                                {token.label}
                            </Box>

                            <Typography sx={{ fontSize: 13, fontWeight: 800 }}>
                                x{token.count * 2}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Stack>
        </Paper>
    );
};

export default PisosMoneyTokens;
